import { InlineAlert as MarmaladeInlineAlert } from "@eventbrite/marmalade"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

// redux
import { setInlineAlertActivationStatus } from "../../../store/slices/alert.slice"

// types
import { RootState } from "../../../store/store"

// styles
import * as styles from "./InlineAlert.module.scss"

export type InlineAlertProps = (typeof MarmaladeInlineAlert)["defaultProps"]

export const InlineAlert = (inlineProps: InlineAlertProps) => {
  const alert = useSelector((State: RootState) => State.alert)
  const { active, ...alertProps } = alert

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(setInlineAlertActivationStatus(false))
    }
  }, [])

  useEffect(() => {
    if (active === true) {
      if (typeof window !== "undefined") {
        window?.scroll(0, 0)
      }
    }
  }, [active])

  if (!active || !alertProps?.description) {
    return null
  }

  return (
    <div className={styles.inlineAlertWrapper}>
      <MarmaladeInlineAlert
        closeOnClick={() => {
          dispatch(setInlineAlertActivationStatus(false))
        }}
        {...alertProps}
        {...inlineProps}
      />
    </div>
  )
}
